import React from 'react';
import { SearchInput } from '../atoms/SearchInput';
import { DROPDOWN_STYLES } from '../constants/styles';

interface SearchBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder }) => (
  <>
    <div style={DROPDOWN_STYLES.searchSection}>
      <SearchInput value={value} onChange={onChange} placeholder={placeholder} />
    </div>
    <div style={DROPDOWN_STYLES.divider} />
  </>
);
